module.exports = __webpack_public_path__ + "img/snowy.73d56635.svg";